<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <!-- <PageBanner pageTitle="Service Details" mainTitle="Service Details" /> -->
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">

                <div class="row">
                  <div class="col-md-9">
                    <h2>Dr. Cocea Eduard Natanael – Medic primar psihiatru</h2>

                    <h2>Co-fondator Clinica Pozitiv Medical</h2>

                    <div class="other-option md-none mt-40">
                      <a href="/#appointment" class="btn style2">
                        Solicită o programare
                      </a>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="team-card style3">
                      <div class="team-img">
                        <img
                          src="../../../assets/images/doctors/dr-cocea-eduard.jpg"
                          alt="Dr. Cocea Eduard Natanael – Psihiatrie"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <p>
                  Sunt <strong>Dr. Cocea Eduard Natanael</strong>, medic primar psihiatru.
                </p>

                <p>
                  Misiunea mea este să ofer suport medical de specialitate pentru
                  diagnosticul și tratamentul tulburărilor emoționale și mintale.
                  Îmbin rigoarea științifică cu o abordare personalizată, adaptată
                  nevoilor unice ale fiecărui pacient.
                </p>

                <p>
                  <em>
                    „O inimă veselă este un bun leac, dar un duh mâhnit usucă oasele.”
                  </em>
                </p>

                <h3>Educație și formare profesională</h3>

                <p>
                  Formarea profesională continuă reprezintă un element important
                  al practicii medicale, contribuind la o abordare actuală și
                  personalizată a fiecărui pacient.
                </p>

                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>
                    2007 – 2013 – Facultatea de Medicină Generală,
                    UMF „Gr. T. Popa”, Iași
                  </li>

                  <li>
                    <i class="ri-check-double-line"></i>
                    2015 – 2019 – Rezidențiat în Psihiatrie,
                    Institutul de Psihiatrie „Socola”, Iași
                  </li>

                  <li>
                    <i class="ri-check-double-line"></i>
                    2025 – Competență în Medicina Adicției, Iași
                  </li>
                </ul>

                <h3>Experiență profesională</h3>

                <p>
                  Activitatea medicală este orientată către evaluarea, diagnosticul
                  și tratamentul tulburărilor psihice și emoționale, cu o abordare
                  individualizată și centrată pe nevoile fiecărui pacient.
                </p>

                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>
                    Diagnostic și tratament în patologia psihiatrică
                  </li>

                  <li>
                    <i class="ri-check-double-line"></i>
                    Evaluarea și managementul tulburărilor emoționale și mintale
                  </li>

                  <li>
                    <i class="ri-check-double-line"></i>
                    Abordarea problematicii dependențelor și a tulburărilor asociate
                  </li>
                </ul>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "CoceaEduardPage",

  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    MainFooter,
  },

  data() {
    return {
      isSticky: false,
    };
  },

  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;

      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>